type ButtonPropsTypes = {
  text: string;
  action: () => void;
};
function BasicButton(props: ButtonPropsTypes) {
  return (
    <div
      className='basic-btn T34B pointer'
      onClick={() => {
        props.action();
      }}
    >
      {props.text}
    </div>
  );
}

function TableStateButton() {
  return (
    <div className='help-btn TO-body-3'>
      <img
        src={"/assets/images/menu/table_clean.svg"}
        alt='help icon'
        width={"100%"}
        height={"100%"}
      />
      테이블 비움 상태입니다.
    </div>
  );
}

function TouchButton() {
  return (
    <div className='touch-btn TO-body-4'>주문하시려면 화면을 터치해주세요</div>
  );
}

type ButtonPropsTypes2 = {
  action: () => void;
};
function LanguageSelectButton(props: ButtonPropsTypes2) {
  return (
    <div
      className='service-lang-btn T34M pointer'
      style={{
        width: "fit-content",
        padding: "0 50px",
        alignSelf: "flex-end",
        margin: "1.5rem",
      }}
      onClick={() => {
        props.action();
      }}
    >
      <img src={"/assets/images/menu/kr.svg"} alt='korea icon' />
      <span>language</span>
    </div>
  );
}

type LangButtonPropsTypes = {
  text: string;
  select: string;
  src: string;
};
function LanguageButton(props: LangButtonPropsTypes) {
  return props.select === props.text ? (
    <div className='service-lang-btn T34M selected-lang'>
      <img src={`/assets/images/menu/${props.src}.svg`} alt={`${props.text}`} />
      <span>{props.text}</span>
    </div>
  ) : (
    <div className='service-lang-btn T34M'>
      <img src={`/assets/images/menu/${props.src}.svg`} alt={`${props.text}`} />
      <span>{props.text}</span>
    </div>
  );
}

export {
  BasicButton,
  TableStateButton,
  TouchButton,
  LanguageSelectButton,
  LanguageButton,
};
